//add _blank link
const links = document.links; 
  for (let i = 0, linksLength = links.length ; i < linksLength ; i++) { 
    if (links[i].hostname !== window.location.hostname) { 
      links[i].target = '_blank'; 
      links[i].rel = 'noreferrer noopener'; 
  } 
}

// add hover submenu header
let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
items.forEach(item => {
item.addEventListener("mouseover", () => {
item.setAttribute("open", true);
item.querySelector("ul").addEventListener("mouseleave", () => {
item.removeAttribute("open");
});
item.addEventListener("mouseleave", () => {
item.removeAttribute("open");
});
});

});


// toggle js Faq index js
function toggleFaq(element) {
    const body = element.nextElementSibling;
    const icon = element.querySelector('.toggle-icon');

    if (body.classList.contains('show')) {
        body.classList.remove('show');
        icon.textContent = '+'; 
        icon.classList.remove('rotate'); 
    } else {
        body.classList.add('show');
        icon.textContent = '✖'; 
        icon.classList.add('rotate');
    }
}

///custom op
// document.addEventListener("DOMContentLoaded", initOption1Sorter);
// document.addEventListener("shopify:section:load", initOption1Sorter);

// function initOption1Sorter() {
//   document.querySelectorAll("variant-selects").forEach(bindVariantSelectsSorter);
// }

// function bindVariantSelectsSorter(variantSelects) {
//   if (!variantSelects) return;

//   applyOption1Sort(variantSelects);

//   if (variantSelects.dataset.option1SorterBound === "true") return;
//   variantSelects.dataset.option1SorterBound = "true";

//   let timer = null;

//   const rerun = () => {
//     clearTimeout(timer);
//     timer = setTimeout(() => {
//       applyOption1Sort(variantSelects);
//     }, 20);
//   };

//   variantSelects.addEventListener("change", rerun);

//   const observer = new MutationObserver(rerun);
//   observer.observe(variantSelects, {
//     childList: true,
//     subtree: true
//   });
// }

// function applyOption1Sort(variantSelects) {
//   const option1Fieldset = getOption1Fieldset(variantSelects);
//   if (!option1Fieldset) return;

//   const radios = Array.from(option1Fieldset.querySelectorAll('input[type="radio"]'));
//   if (radios.length <= 1) return;

//   const items = radios.map((radio, index) => {
//     const label = option1Fieldset.querySelector(`label[for="${radio.id}"]`);
//     const text = getCleanOptionText(radio, label);
//     const size = parseDataSize(text);

//     return {
//       radio,
//       label,
//       text,
//       size,
//       index
//     };
//   }).filter(item => item.label);

//   if (items.length <= 1) return;

//   items.sort((a, b) => {
//     const aValid = Number.isFinite(a.size);
//     const bValid = Number.isFinite(b.size);

//     if (aValid && bValid) {
//       return b.size - a.size;
//     }

//     if (aValid && !bValid) return -1;
//     if (!aValid && bValid) return 1;

//     return a.index - b.index;
//   });

//   const currentOrder = radios.map(radio => radio.id).join("|");
//   const sortedOrder = items.map(item => item.radio.id).join("|");

//   if (currentOrder === sortedOrder) return;

//   const fragment = document.createDocumentFragment();

//   items.forEach(({ radio, label }) => {
//     fragment.appendChild(radio);
//     fragment.appendChild(label);
//   });

//   option1Fieldset.appendChild(fragment);
// }

// function getOption1Fieldset(variantSelects) {
//   const fieldsets = variantSelects.querySelectorAll("fieldset.product-form__input");
//   if (!fieldsets.length) return null;

//   for (const fieldset of fieldsets) {
//     const radios = fieldset.querySelectorAll('input[type="radio"]');
//     if (!radios.length) continue;

//     const firstRadio = radios[0];
//     const name = String(firstRadio.getAttribute("name") || "").replace(/\s+/g, "");

//     if (name.endsWith("-1")) {
//       return fieldset;
//     }
//   }

//   return fieldsets[0] || null;
// }

// function getCleanOptionText(radio, label) {
//   const value = String(radio?.value || "").trim();
//   if (value) return value;

//   if (!label) return "";

//   const clone = label.cloneNode(true);
//   clone.querySelectorAll(".visually-hidden, .label-unavailable").forEach(el => el.remove());

//   return clone.textContent.replace(/\s+/g, " ").trim();
// }

// function parseDataSize(text) {
//   const normalized = String(text || "")
//     .toUpperCase()
//     .replace(/,/g, "")
//     .replace(/\s+/g, "")
//     .trim();

//   const match = normalized.match(/(\d+(?:\.\d+)?)(TB|GB|MB|KB|B)/);
//   if (!match) return NaN;

//   const value = parseFloat(match[1]);
//   const unit = match[2];

//   switch (unit) {
//     case "TB":
//       return value * 1024 * 1024 * 1024 * 1024;
//     case "GB":
//       return value * 1024 * 1024 * 1024;
//     case "MB":
//       return value * 1024 * 1024;
//     case "KB":
//       return value * 1024;
//     case "B":
//       return value;
//     default:
//       return NaN;
//   }
// }